import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button
} from '@material-ui/core';
import useSound from 'use-sound';

// Rename the component to reflect its specific purpose, if desired
function ConfirmationDialog(props) {
  const [play] = useSound('/media/sounds/1-second-of-silence.mp3');

  // Handler that plays the sound then performs the onClose action
  const handleConfirm = () => {
    play();
    setTimeout(() => {
      if (props.onClose) {
        props.onClose();
      }
    }, 150); // Short delay to let the sound play
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} aria-labelledby="confirmation-dialog-title">
      <DialogTitle id="confirmation-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
